import classNames from "classnames"
import React from "react"

import type { PNImageProps } from "@bounce/web-components"
import { Button, PNImage } from "@bounce/web-components"

export type BannerProps = {
  image?: PNImageProps["src"]
  title: string
  subtitle: string
  ctaSubtitle?: React.ReactNode
  ctaLabel: string
  ctaOnClick: () => void
  className?: string
}

export const Banner = ({ image, title, subtitle, ctaSubtitle, ctaLabel, ctaOnClick, className }: BannerProps) => (
  <aside className={classNames("flex flex-1 flex-col pt-8", className)}>
    <div className="flex flex-1 flex-col items-center rounded-lg bg-neutral-100 px-7 pb-7">
      {!!image && (
        <PNImage
          alt=""
          src={image}
          loading="lazy"
          width={200}
          height={200}
          className="relative -mt-8 object-contain object-center"
        />
      )}
      <h2 className="mt-8 w-full text-xl font-semibold">{title}</h2>
      <p className="paragraph1 mb-10 mt-3 w-full !text-sm !leading-relaxed">{subtitle}</p>
      {!!ctaSubtitle && <p className="paragraph1 mb-5 w-full flex-1 !text-sm">{ctaSubtitle}</p>}
      <Button as="button" onClick={ctaOnClick} size="sm" className="w-full">
        {ctaLabel}
      </Button>
    </div>
  </aside>
)
